import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowright = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.875 0.374998L9.82609 2.4239L17.9345 10.5469L0.250002 10.5469L0.250002 13.4531L17.9345 13.4531L9.8261 21.5761L11.875 23.625L23.5 12L11.875 0.374998Z",
		fill: "black"
	})
});
export default SvgArrowright;
